<template>
  <div class="browser-window bg-dirty">
    <div class="browser-window__tabs">
      <span class="content"
        ><span v-if="project.name" class="text-dblue-600"
          >{{ project.name }} Feedback</span
        ><span v-else class="text-dblue-400">New project Feedback</span>
      </span>
    </div>
    <div class="browser-window__url">
      <span class="content"
        ><span class="text-dblue-300">https://</span
        ><span v-if="project.url" class="text-dblue-500 font-medium">{{
          project.url
        }}</span
        ><span v-else class="text-dblue-300">new-project</span
        ><span class="text-dblue-500">.feedbear.com</span></span
      >
    </div>
    <div class="browser-window__body">
      <img :src="logoPreview" alt="" v-if="project.logo" class="logo-preview" />
      <div class="browser-window__project-name" v-else>
        <span v-if="project.name" class="text-dblue-600">{{
          project.name
        }}</span>
        <span v-else class="text-dblue-400">New project</span>
      </div>

      <div class="flex">
        <div class="text-sm text-dblue-600 font-medium mt-1 mr-2">Roadmap</div>
        <div class="text-sm text-dblue-600 mt-1">
          {{ board.name }}
        </div>
      </div>

      <div class="flex items-start mt-3">
        <div class="roadmap__col mr-1 roadmap__col--filled">
          <div class="roadmap__item">
            {{ posts.first.title }}
          </div>
          <div class="roadmap__item"></div>
          <div class="roadmap__item"></div>
        </div>
        <div class="roadmap__col mx-1 roadmap__col--filled">
          <div class="roadmap__item">
            {{ posts.second.title }}
          </div>
          <div class="roadmap__item"></div>
        </div>
        <div class="roadmap__col ml-1 roadmap__col--filled">
          <div class="roadmap__item">
            {{ posts.third.title }}
          </div>
          <div class="roadmap__item"></div>
          <div class="roadmap__item"></div>
          <div class="roadmap__item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["project", "board", "posts"],

  computed: {
    logoPreview() {
      return URL.createObjectURL(this.project.logo);
    },
  },
};
</script>

<style scoped>
.browser-window {
  height: 22rem;
  @apply rounded-lg w-full max-w-lg mx-auto shadow-lg flex flex-col;
}

.browser-window__tabs {
  @apply bg-dblue-200 h-10 w-full flex items-end rounded-t-md;
}

.browser-window__tabs .content {
  line-height: 2rem;
  @apply flex items-center h-8 w-48 bg-dblue-100 ml-2 rounded-t px-2 text-sm text-dblue-500 ring-1 ring-black ring-opacity-5 relative z-10;
}

.browser-window__tabs .content span {
  overflow: hidden;
  display: block;
  max-height: 100%;
  word-break: break-all;
}

.browser-window__tabs .content::before {
  content: "";
  right: 0;
  top: 0;
  width: 2rem;
  background: linear-gradient(90deg, rgba(234, 236, 238, 0), #eaecee);
  @apply absolute h-full rounded-tr;
}

.browser-window__tabs .content::after {
  content: "";
  height: 1px;
  bottom: -1px;
  left: 0;
  @apply block absolute w-full bg-dblue-100;
}

.browser-window__url {
  @apply w-full h-10 bg-dblue-100 flex items-center relative z-0 ring-1 ring-black ring-opacity-5;
}

.browser-window__url .content {
  line-height: 1.5rem;
  @apply block h-6 w-full mx-2 rounded-full bg-white px-2 text-sm;
}

.browser-window__body {
  @apply pt-2 px-3;
}

.logo-preview {
  max-width: 7rem;
  max-height: 2rem;
}

.browser-window__project-name {
  @apply text-base;
}

.navbox {
  height: 0.8rem;
  @apply bg-dblue-200 rounded mt-2;
}

.roadmap__col {
  @apply w-1/3 bg-white shadow-sm rounded pt-8 relative;
}

.roadmap__col::before {
  content: "";
  width: 4rem;
  height: 1rem;
  top: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  @apply absolute bg-dblue-100 rounded text-sm text-dblue-400 text-center font-medium;
}

.roadmap__col--filled::before {
  width: 100%;
  @apply bg-white;
}

.roadmap__col--filled:nth-child(1)::before {
  content: "Planned";
  color: #5a73c1;
}

.roadmap__col--filled:nth-child(2)::before {
  content: "In progress";
  color: #05867b;
}

.roadmap__col--filled:nth-child(3)::before {
  content: "Done";
  color: #0b8200;
}

.roadmap__item {
  min-height: 2rem;
  @apply border-2 border-dblue-100 rounded m-1 bg-white px-2 flex items-center text-xs font-medium text-dblue-500;
}
</style>
